import { Doctor } from "widgets/doctor"

export const DoctorPage = () => {
  return (
    <Doctor />
  )
}